module.exports = "/assets/data/47255dcbd01f8ffc312b4a8de36669d8-SW7.data.json";